
export default {
  name: 'InputEmail',
  props: {
    name: {
      type: String,
      default: 'name',
    },
    label: {
      type: String,
      default: 'Email Address',
    },
    placeholder: {
      type: String,
      default: '@',
    },
    option: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
